import { Routes } from '@angular/router';
import { UserPageComponent } from './containers/user-page/user-page.component';
import { UserSearchPageComponent } from './containers/user-search-page/user-search-page.component';

export const USER_ROUTES: Routes = [
  {
    path: 'users',
    component: UserSearchPageComponent,
    data: { title: 'Users | One Back Office' },
  },
  {
    path: 'users/:userId',
    component: UserPageComponent,
  },
];
